import React, {
  useEffect,
  useState,
} from "react";

import { useParams } from "react-router-dom";

import { auth } from "@/api";


export default function VerifyEmail() {
  const { token } = useParams();

  const [message, setMessage] = useState(
    "Confirmation en cours..."
  );


  useEffect(() => {
    auth
      .verifyEmail(token)
      .then(() => {
        setMessage(
          "Votre e-mail est confirmé."
        );
      })
      .catch(() => {
        setMessage(
          "Lien invalide ou expiré."
        );
      });
  }, [token]);


  return (
    <main className="auth-page">
      <section className="auth-card">
        <h1>
          Confirmation e-mail
        </h1>

        <p>
          {message}
        </p>
      </section>
    </main>
  );
}
